<app-menu></app-menu>
<mat-toolbar color="primary"> Promote dynamic image sets</mat-toolbar>
<div style="margin: auto">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="promoteForm">
        <mat-card class="mat-elevation-z0 card-padding">
          <mat-card-subtitle>From area to area</mat-card-subtitle>
          <mat-radio-group formControlName="area">
            <mat-radio-button
              class="col-lg-2"
              *ngFor="let v of areas"
              id="{{ v }}"
              [value]="v"
              ><label>{{ v }}</label></mat-radio-button
            >
          </mat-radio-group>
        </mat-card>
        <mat-card class="mat-elevation-z0 card-padding">
          <mat-card-subtitle>Status</mat-card-subtitle>
          <mat-checkbox
            class="col-sm-2"
            formControlName="notPromoted"
            [value]="promoteSet.notPromoted"
            ><span>not promoted</span>
          </mat-checkbox>
          <mat-checkbox
            class="col-sm-2"
            formControlName="toPreProd"
            [value]="promoteSet.toPreProd"
            ><span>to Pre-Prod</span>
          </mat-checkbox>
          <mat-checkbox
            class="col-sm-2"
            formControlName="toProd"
            [value]="promoteSet.toProd"
            ><span>to Prod</span>
          </mat-checkbox>
        </mat-card>
        <mat-card class="mat-elevation-z0 card-padding">
          <mat-form-field class="col-sm-6">
            <input
              type="text"
              matNativeControl
              placeholder="Enter Dynamic Image Set Id"
              label="Enter Dynamic Image Set Id"
              formControlName="disId"
              id="deploymentSetName"
              [matAutocomplete]="auto"
              (keydown.enter)="$event.preventDefault()"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectedItem($event)"
            >
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </mat-card>

        <mat-card class="mat-elevation-z0 card-padding">
          <mat-card-subtitle>Last uploaded from-to</mat-card-subtitle>
          <mat-form-field appearance="fill" class="col-sm-6">
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="from" placeholder="From" />
              <input matEndDate formControlName="to" placeholder="To" />
            </mat-date-range-input>

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </mat-card>

        <mat-card class="mat-elevation-z0 card-padding">
          <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="disId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Dynamic Image Set Id
              </th>
              <td mat-cell *matCellDef="let element">{{ element.disId }}</td>
            </ng-container>

            <ng-container matColumnDef="lastModifiedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Last upload
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.lastModifiedDate | date: "medium":"+0200":"de" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lastPreprodPromoteDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Last promotion to pre-prod
              </th>
              <td mat-cell *matCellDef="let element">
                {{
                  element.lastPreprodPromoteDate | date: "medium":"+0200":"de"
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lastProdPromoteDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Last promotion to prod
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.lastProdPromoteDate | date: "medium":"+0200":"de" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="promoteAll">
              <th mat-header-cell *matHeaderCellDef>Promote All</th>
              <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="promoteAll(row.disId)">Promote All</button></td>
            </ng-container>

            <ng-container matColumnDef="promoteMeta">
              <th mat-header-cell *matHeaderCellDef>Promote Metadata only</th>
              <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="promoteMeta(row.disId)">Promote Meta</button></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
        </mat-card>

      </form>
    </mat-card-content>
  </mat-card>
</div>
